export default class CustomAreaPointData {
    constructor(latitude, longitude, position) {
        this.latitude = latitude,
            this.longitude = longitude,
            this.position = position
    }
}